import JQueryView from '../../../../../../common/views/jqueryView';
// @ts-expect-error モジュール 'sweetalert' に型定義が無いため
import swal from 'sweetalert';

export default class FormView extends JQueryView {
  constructor(displayConfirmationAlert: boolean) {
    super('.my-investors-wizard');

    if (displayConfirmationAlert) {
      swal({
        title:
          'メールアドレスの確認が完了しておりません。画面上部のメッセージを確認してください。',
        confirmButtonColor: '#2196F3',
        animation: false,
      });
    }
  }
}
